import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { IoArrowForwardOutline } from 'react-icons/io5';
import { SectionHeader } from '../ui/SectionHeader';

export const BlogSection = () => {
  const { blogs } = useStaticQuery(graphql`
    query getAllBlogs {
      blogs: allContentfulBlogPost(limit: 3) {
        edges {
          node {
            title
            slug
            metaDescription {
              metaDescription
            }
            featuredImage {
              ... on ContentfulAsset {
                contentful_id
                title
                gatsbyImageData(width: 600, height: 600, placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  `);

  return (
    <section className="container py-2">
      <SectionHeader
        heading="Recent Blog Posts"
        subheading="Learn about thriving as a digital nomad, get insightful remote working tips, and read more about the nomadic lifestyle"
      />

      <div className="-mx-4 overflow-auto">
        <ul className="px-4 grid grid-cols-3 w-[200%] md:w-auto gap-4 mt-6 mb-8 sm:mt-12 sm:mb-14">
          {blogs.edges.map(({ node: blog }: any) => (
            <li key={blog?.slug} className="relative bg-white">
              <Link
                to={`/blog/${blog?.slug}/`}
                className="relative block w-full mb-4 overflow-hidden transition-all duration-300 bg-white rounded-md shadow hover:opacity-90 hover:shadow-lg"
              >
                <GatsbyImage
                  image={blog?.featuredImage?.gatsbyImageData}
                  alt={blog?.featuredImage?.title}
                  imgClassName="relative"
                />
              </Link>

              <Link to={`/blog/${blog?.slug}/`} className="inline-block mb-2">
                <h3>{blog?.title}</h3>
              </Link>

              <p className="text-black transition-colors">
                {(blog?.metaDescription?.metaDescription || '')
                  ?.split(' ')
                  ?.slice(0, 30)
                  ?.join(' ')
                  ?.concat('...')}
              </p>

              <Link
                to={`/blog/${blog?.slug}/`}
                className="flex items-center py-2 group"
              >
                Keep Reading
                <IoArrowForwardOutline className="ml-1 text-blue-400 group-hover:translate-x-0.5 transform transition-transform" />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="sticky left-0 flex justify-center">
        <Link to="/blog/" className="w-full button button--primary sm:max-w-60">
          View All Posts
        </Link>
      </div>
    </section>
  );
};
